import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./Components/Navbar";
import Breadcrumbs from "./Components/Breadcrumbs";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Residential from "./Pages/Residential";
import Commercial from "./Pages/Commercial";
import Contact from "./Components/Contact";

import Gallery from "./Pages/Gallery";
import Services from "./Pages/Services";
import LocationPage from "./Pages/LocationPage";
import NotFound from "./Pages/NotFound";
import Footer from "./Components/Footer";
import FixedCall from "./Components/FixedCall";
import FixedContact from "./Components/FixedContact";

function App() {
  return (
    <Router>
      <Navbar />
      <Breadcrumbs />
      <FixedContact />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/residential" element={<Residential />} />
        <Route path="/commercial" element={<Commercial />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />

        {/* Dedicated Local SEO Regional Landing Pages */}
        <Route path="/usilampatti" element={<LocationPage locationKey="usilampatti" />} />
        <Route path="/karaikudi" element={<LocationPage locationKey="karaikudi" />} />
        <Route path="/sivaganga" element={<LocationPage locationKey="sivaganga" />} />
        <Route path="/thiruppuvanam" element={<LocationPage locationKey="thiruppuvanam" />} />
        <Route path="/theni" element={<LocationPage locationKey="theni" />} />
        <Route path="/location/:citySlug" element={<LocationPage />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <FixedCall />
    </Router>
  );
}

export default App;
